<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-xl">
          <div ref="cockpit-and-filter" class="card">
            <div class="card-header" >
              <div class="form-row">
                <div class="form-group col-md">
                    <treeselect :placeholder="$t('Webportal.SurveyFilter.Placeholder')"
                                ref="projectTreeselect"
                                instance-id="projects"
                                v-model="selection.projects"
                                :options="filterValues.projects"
                                :auto-load-root-options="false"
                                :multiple="true"
                                :max-height="600"
                                :disable-branch-nodes="true"
                                :searchable="true"
                                :clearable="true"
                                :disableFuzzyMatching="true"
                                :showCount="true"
                                :flat="false"
                                showCountOf="LEAF_DESCENDANTS"
                                :disabled="isLoading"
                                @open="handleTreeselectOpen"
                                @input="handleTreeselectInput"
                                @close="handleTreeselectClose" />
                </div>
                <div class="form-group col-md">
                    <treeselect :placeholder="$t('Webportal.WaveFilter.Placeholder')"
                                ref="waveTreeselect"
                                instance-id="waves"
                                v-model="selection.waves"
                                :options="filterValues.waves"
                                :auto-load-root-options="false"
                                :multiple="true"
                                :searchable="true"
                                :disableFuzzyMatching="true"
                                :showCount="true"
                                :flat="true"
                                showCountOf="LEAF_DESCENDANTS"
                                @open="handleTreeselectOpen"
                                @input="handleTreeselectInput"
                                @close="handleTreeselectClose"
                                :disabled="isLoading" />
                  </div>
                <div class="form-group col-md">
                    <treeselect :placeholder="$t('Webportal.ScenarioFilter.Placeholder')"
                                ref="scenarioTreeselect"
                                instance-id="scenario"
                                v-model="selection.scenarios"
                                :options="filterValues.scenarios"
                                :auto-load-root-options="false"
                                :multiple="true"
                                :searchable="true"
                                :disableFuzzyMatching="true"
                                :showCount="true"
                                :flat="true"
                                showCountOf="LEAF_DESCENDANTS"
                                @open="handleTreeselectOpen"
                                @input="handleTreeselectInput"
                                @close="handleTreeselectClose"
                                :disabled="isLoading" />
                  </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md">
                    <treeselect :placeholder="$t('Webportal.LocationFilter.Placeholder')"
                                ref="locationTreeselect"
                                instance-id="location"
                                v-model="selection.locations"
                                :options="filterValues.locations"
                                :auto-load-root-options="false"
                                :multiple="true"
                                :searchable="true"
                                :disableFuzzyMatching="true"
                                :showCount="true"
                                :flat="true"
                                showCountOf="LEAF_DESCENDANTS"
                                @open="handleTreeselectOpen"
                                @input="handleTreeselectInput"
                                @close="handleTreeselectClose"
                                :disabled="isLoading" />
                  </div>
                <div class="form-group col-md"
                     v-for="(cust, index) in filterValues.customProperties" :key="index">
                      <treeselect :placeholder="cust.label"
                                  :ref="getRefName(cust)"
                                  :instance-id="cust.id"
                                  v-model="selection.customProperties[index]"
                                  :options="cust.children"
                                  :auto-load-root-options="false"
                                  :multiple="true"
                                  :searchable="true"
                                  :disableFuzzyMatching="true"
                                  :showCount="true"
                                  :flat="true"
                                  showCountOf="LEAF_DESCENDANTS"
                                  :disabled="isLoading"
                                  :disable-branch-nodes="true"
                                  @open="handleTreeselectOpen"
                                  @input="handleTreeselectInput"
                                  @close="handleTreeselectClose"/>
                    </div>
              </div>

              <div class="row" style="align-items: center;">
                <div class="col">
                  <div class="headinfos">
                    <h3>MYSTERY SHOPPING PERFORMANCE<br/></h3>
                  </div>
                </div>

                <div class="col-md-auto row">
                  <label for="KpiClusterSwitch" class="col-md-auto">
                    {{ $t('KPI') }}
                  </label>
                  <label class="switch switch-label switch-secondary">
                    <input class="switch-input" type="checkbox"
                          v-model="KpiClusterSwitch"
                          v-validate data-vv-name="KpiClusterSwitch"
                          :disabled="isLoading || !isKpiAvailable">
                    <span class="switch-slider" data-checked="" data-unchecked=""></span>
                  </label>
                  <label for="KpiClusterSwitch" class="col-md-auto">
                    {{ $t('Cluster') }}
                  </label>
                </div>
                <div class="col-md-auto">
                  <exportelementbutton elementRef="cockpit" right
                                      :additionalElements="[{ Name: $t('Webportal.Dashboard.Export.IncludeFilter'),
                                                              ElementRef: 'cockpit-and-filter' }]"
                                      fileName="Cockpit"
                                      :disabled="showPlaceholder || isLoading" />
                </div>
              </div>
            </div>

            <div ref="cockpit" v-if="dashdata"
                 v-bind:class="{ spinner: isLoading }"
                 class="card-body"
                 style="min-height:300px;">
              <dashboardpanel :dashdata="dashdata"
                              :colors="colors" />
            </div>
            <div v-if="!dashdata" style="min-height: 200px;">
              <h5 style="text-align: center; margin-top: 5rem;">No data available</h5>
            </div>
          </div>

        </div>
      </div>
    </div>

   <!-- <b-modal ref="modalTooMuchWaves" id="modal-center" centered :title="$t('Webportal.Dashboard.Dialog.MaxWaves.Title')">
      <p class="my-4">{{ $t('Webportal.Dashboard.Dialog.MaxWaves.Text') }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="closeInfoDialog">
          {{ $t('Webportal.Dashboard.Ok') }}
        </b-btn>
      </div>
    </b-modal> -->
  </div>

</template>


<script>
  import axios from 'axios'
  import EventBus from '@/services/EventBus.js'
  import DashboardService from '@/services/DashboardService-aldisued'
  import dashboardpanel from '@/components/Dashboard-aldisued/DashboardPanel'
  import exportelementbutton from './ExportElementButton'
  import moment from "moment";
  import LocalizationChangedWithFilter from '@/mixins/LocalizationChangedWithFilter';
  import { DxBox, DxItem } from 'devextreme-vue/box';

  export default {
    name: "Dashboard",

    mixins: [ LocalizationChangedWithFilter ],

    components:{
      dashboardpanel,
      exportelementbutton,
      DxBox,
      DxItem
    },

    created() {
      // console.log('Dashboard - created');

      this.getfilterValues();
      EventBus.$on('LocalizationChanged', this.localizationChanged);
    },

    mounted(){
      // console.log('Dashboard - mounted');

      this.isMounted = true;
    },

    beforeDestroy() {
      // console.log('Dashboard - beforeDestroy');

      EventBus.$off('LocalizationChanged', this.localizationChanged);
    },

    data() {
      return {

        filterValues: {
          clients: [], // not used for generic reporting
          projects: [],
          surveys: [],
          waves: [],
          scenarios: [],
          locations: [],
          customProperties: []
        },

        selection: {
          client: null, // not used for generic reporting
          projects: [],
          surveys: [],
          waves: [],
          scenarios: [],
          locations: [],
          customProperties: []
        },

        lastFilterSelection: null,

        KpiClusterSwitch: true,

        isLoading: true,
        isSettingFilterValues: true,
        isMounted: false,
        isTreeselectOpen: false,

        cockpitCancelToken: null,
        optionsCancelToken: null,

        dashdata: null,

        colors: ['#FF1500', '#FFD800', '#4CFF00'], // red, yellow, green
        toolTipDelay: { delay: { "show": 500, "hide": 100 } }
      }
    },

    methods: {

      // ***********************************************************
      // HTML Events
      // ***********************************************************

      // Treeselect
      // **********

      handleTreeselectOpen(instanceId) {
        // console.log('Dashboard - handleTreeselectOpen');

        this.isTreeselectOpen = true;
      },

      handleTreeselectClose(value, instanceId) {
        // console.log('Dashboard - handleTreeselectClose');

        this.isTreeselectOpen = false;
        
        if (this.checkFilterChanged()) {
          this.getDashboard();
        }
      },

      handleTreeselectInput(value, instanceId) {
        // console.log('Dashboard - handleTreeselectInput');
       
        if (this.isSettingFilterValues || this.isLoading || !this.isMounted || this.isTreeselectOpen) {
          return;
        }

        if (this.checkFilterChanged()) {
          this.getDashboard();
        }
      },

      // ***********************************************************
      // Public methods
      // ***********************************************************
      getRefName(cust) {
        // console.log('Dashboard - getRefName');

        return cust.name + 'Treeselect';
      },

      closeInfoDialog() {
        // console.log('Dashboard - closeInfoDialog');

        this.$refs.modalTooMuchWaves.hide();
      },


      // ***********************************************************
      // Private methods
      // ***********************************************************
      getDashboard() {
        // console.log('Dashboard - getDashboard');

        // Cancel previous request
        const token = this.initCancelToken(this.cockpitCancelToken);

        this.isLoading = true;

        try {
          this.lastFilterSelection = this.getCurrentFilterFromSelection();
          DashboardService.getDashboard(this.lastFilterSelection, token)
            .then(response => { this.dashdata = this.initDashdata(response.data); });
        } finally { 
          this.isLoading = false; 
        }

      },

      initDashdata(dash) {
        // console.log('Dashboard - initDashdata');

        if (!dash) { return dash; }

        dash.list = [];

        if (_.isEmpty(dash.KPI)) {
            return null;
        }

        // console.log(JSON.stringify(dash));

        let kpiQuestionParents = [];

        // KPI
        dash.KPI.forEach(kpi => {
            let item = {
                SortIndex: 1000000 - Number.parseInt(kpi.KpiCode.substring(0,1)),
                KpiCode: kpi.KpiCode,
                Weighting: 'N/A',
                KpiGroupCode: kpi.KpiGroupCode,
                KpiName: kpi.KpiName,
                SurveyWave: kpi.SurveyWave,
                KpiCodeParent: '0',
                Diff: this.calculateDelta(_.last(kpi.SurveyWave), _.first(kpi.SurveyWave))
            };

            if (kpi.KpiCode !== 'General Information' && kpi.KpiCode !== 'Statistics') {
                dash.list.push(item);
            }
        });

        // Questions
        if (!_.isEmpty(dash.Question)) {
            dash.Question.forEach(q => {
                let item = {
                    SortIndex: 1000000 - Number.parseInt(q.KpiCode.substring(0,1)),
                    KpiCode: q.QuestionCode,
                    KpiGroupCode: q.KpiGroupCode,
                    KpiName: q.QuestionText,
                    SurveyWave: q.SurveyWave,
                    KpiCodeParent: q.KpiCode,
                    Diff: this.calculateDelta(_.last(q.SurveyWave), _.first(q.SurveyWave))
                };

                kpiQuestionParents.push({
                    id: q.KpiCode.substring(0, 1),
                    KpiCodeParent: q.KpiCode
                });

                if (q.KpiCode !== 'General Information' && q.KpiCode !== 'Statistics') {
                    dash.list.push(item);
                }
            });
        }

        // Fehlartikel
        if (!_.isEmpty(dash.Fehlartikel)) {
            dash.Fehlartikel.forEach(fa => {

                    let kpiParentId = fa.KpiCode;
                    
                    if (kpiParentId) {                        
                        dash.list.push({
                            SortIndex: fa.Anzahl,
                            KpiCode: kpiParentId.substring(0,1) + 'FA-' + fa.Artikelnummer,
                            KpiName: fa.Artikelnummer,
                            KpiFehlartikel: fa.Artikelbezeichnung ? fa.Artikelbezeichnung : 'N/A',
                            KpiFehlartikelAnzahl: fa.Anzahl,
                            SurveyWave: [],
                            KpiCodeParent: kpiParentId
                        });
                    }
            });
        }

        // console.log(JSON.stringify(dash));

        return dash;
      },

    calculateDelta(act, prev) {
        if (!act || !prev) { return 0; }
        if (!act.Result || !prev.Result) { return 0; }
        return act.Result - prev.Result;
    },

      initCancelToken(token) {
        // console.log('Dashboard - initCancelToken');

        // Cancel previous request
        if (token)
          token.cancel();
        return axios.CancelToken.source();
      },

      getfilterValues() {
        // console.log('Dashboard - getfilterValues');

        this.isLoading = true;
        const optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

        try {
          DashboardService.getOptions(null, this.getCurrentFilterFromSelection(), optionsCancelToken).then(response => {
            if (response.data) {
              // console.log('Dashboard - getfilterValues received data: ' + JSON.stringify(response.data));
              this.setFilterValues(response.data);
            }
          });
        } finally {
          this.isLoading = false;
        }
      },

      setFilterValues(filterdata) {
        // console.log('Dashboard - setFilterValues');

        this.isSettingFilterValues = true;

        try {
          // clear selection and last filter
          this.lastFilterSelection = null;
          this.selection.client = null;
          this.selection.projects = [];
          this.selection.surveys = [];
          this.selection.waves = [];
          this.selection.scenarios = [];
          this.selection.locations = [];
          this.selection.customProperties = [];

          // take it all
          if (filterdata) {
            this.filterValues = filterdata;
          }

          // preselect filters, if only one item exists
          // projects/surveys
          if (this.filterValues.projects && this.filterValues.projects.length === 1 && this.filterValues.projects[0].children && this.filterValues.projects[0].children.length === 1) {
            this.selection.projects = [this.filterValues.projects[0].children[0].id];
          }

          // wave
          if (this.filterValues.waves && this.filterValues.waves.length === 1) {
            this.selection.waves = [this.filterValues.waves[0].id];
          }

          // scenario
          if (this.filterValues.scenarios && this.filterValues.scenarios.length === 1) {
            this.selection.scenarios = [this.filterValues.scenarios[0].id];
          }

          // location
          if (this.filterValues.locations && this.filterValues.locations.length === 1) {
            this.selection.locations = [this.filterValues.locations[0].id];
          }

          // custom properties
          if (this.filterValues.customProperties) {
            let propSelection = [];
            this.filterValues.customProperties.forEach(prop => {
              if (prop.children.length === 1) {
                propSelection.push([prop.children[0].id]);
              } else {
                propSelection.push([]);
              }
            });
            this.selection.customProperties = propSelection;
          }
        } finally {
          this.isSettingFilterValues = false;
        }
      },

      getCurrentFilterFromSelection() {
        // console.log('Dashboard - getCurrentFilterFromSelection');

        let currentFilter = {
          client: null, // not used for generic reporting
          projects: null,
          surveys: null,
          waves: null,
          scenarios: null,
          locations: null,
          customProperties: null
        }

        // since we use one filter box for project/survey combi,
        // we have to include seperation logic here, because
        // the database filter uses them seperately
        if (this.selection.projects && this.selection.projects.length > 0) {
          let selectedProjects = [];
          let selectedSurveys = [];

          // the selection.projects will contain the survey id, so we have to determine the project id of it (parent)
          for (const surveyId of this.selection.projects) {
            for (const proj of this.filterValues.projects)
            {
              if (proj.children) {
                let item = proj.children.find(child => child.id === surveyId);
                if (item) {
                  selectedProjects.push(item.projectId.substring(1)); // remove 'P' from id
                  break;
                }
              }
            }
          }

          // remove 'S' from ids
          for (let i=0; i<this.selection.projects.length; i++) {
            selectedSurveys.push(this.selection.projects[i].substring(1));
          }

          currentFilter.projects = selectedProjects.filter(function(item, pos, self) {return self.indexOf(item) == pos;}).join(",");
          currentFilter.surveys = selectedSurveys.filter(function(item, pos, self) {return self.indexOf(item) == pos;}).join(",");
        }

        // waves
        if (this.selection.waves && this.selection.waves.length > 0) {
          currentFilter.waves = this.selection.waves.join(",");
        }

        // scenarios
        if (this.selection.scenarios && this.selection.scenarios.length > 0) {
          currentFilter.scenarios = this.selection.scenarios.join(",");
        }

        // locations
        if (this.selection.locations && this.selection.locations.length > 0) {
          currentFilter.locations = this.selection.locations.join(",");
        }

        // custom properties
        if (this.selection.customProperties && this.selection.customProperties.length > 0) {

          // for each custom property filter box
          for (var i=0; i < this.selection.customProperties.length; i++) {
            
            // for each filtered item
            for (const selectedId of this.selection.customProperties[i]) {
              const propItem = (this.filterValues.customProperties[i].children).find(obj => obj.id === selectedId);
              if (propItem) {
                if (currentFilter.customProperties) {
                  currentFilter.customProperties += '|' + propItem.id;
                } else {
                  currentFilter.customProperties = propItem.id;
                }
              }
            }
          }
        }

        // console.log('Dashboard - getCurrentFilterFromSelection - filter: ' + JSON.stringify(currentFilter));
        return currentFilter;
      },

      checkFilterChanged() {
        // console.log('Dashboard - checkFilterChanged');

        let retVal = false;

        // if no last filter selection available treat it like a filter change
        if (!this.lastFilterSelection) {
          // console.log('Dashboard - checkFilterChanged - Return: true');
          return true;
        }

        // check each filter selection
        const currentFilterSelection = this.getCurrentFilterFromSelection();

        retVal = currentFilterSelection.client !== this.lastFilterSelection.client;
        retVal = retVal | currentFilterSelection.projects !== this.lastFilterSelection.projects;
        retVal = retVal | currentFilterSelection.surveys !== this.lastFilterSelection.surveys;
        retVal = retVal | currentFilterSelection.waves !== this.lastFilterSelection.waves;
        retVal = retVal | currentFilterSelection.scenarios !== this.lastFilterSelection.scenarios;
        retVal = retVal | currentFilterSelection.locations !== this.lastFilterSelection.locations;
        retVal = retVal | currentFilterSelection.customProperties !== this.lastFilterSelection.customProperties;

        // console.log('Dashboard - checkFilterChanged - Return: ' + (retVal ? 'true' : 'false'));

        return retVal;
      }

    },

    computed: {

      showPlaceholder: function() {
        let retVal = !this.dashdata || !this.selection.projects;
        //console.log('Dashboard - showPlaceholder: ' + retVal);
        return retVal;
      },

      isKpiAvailable: function() {
        // TODO: add KPI available logic here...
        return false;
      }
    }
  }

</script>

<style scoped>

.emptyplacehold{
  width: 100%;
  height: 200%;
  text-align: center;
  margin-top: 7em;
}

.container{
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  width: 100%;
}

.card{
  margin-bottom: 20px;
  word-wrap: unset;
}

.card-body{
  min-height: 150px;
}

  selected {
    color: #222222;
  }

  .headinfos{
    display: inline-block;
    width: 100%;
  }

  .bottomline {
    bottom: 0px;
  }

  .navListBorder {
    width: 120px;
    float: right;
    bottom: 0px;
    -webkit-padding-start: 0px;
    border-top: 2px solid #bfbfbf;
    border-left: 2px solid #bfbfbf;
  }

  .navLineBorder {
    float: right;
    bottom: 0px;
    width: 400px;
    -webkit-padding-start: 0px;
    border-top: 2px solid #bfbfbf;
    border-left: 2px solid #bfbfbf;
  }

  nav ul {
    list-style-type: none;
    font-size: 11pt;
    font-weight: bold;
    margin-bottom: 0px;
    margin-top: 6px;
    -webkit-padding-start: 12px;

    color: #bfbfbf;
  }
  .customerlogo{
    float: right;
    right: 0px;
    bottom: 0px;
    margin: 6px;
    margin-top:0px;
    margin-bottom: 7.5px;
  }
  .rightMenu {
    float: right;
    width: auto;
  }

  h3 {
    color: #8fa1bc;
    margin-bottom: 0px;
    font-size: 16pt;
    float: left;
    font-stretch: extra-condensed;
  }

  .switch-slider {
    background-color: #6c757d;
  }

  .switch-label .switch-slider::after {
    color: #fff;
  }
</style>
